import clsx from 'clsx'
import { Parallax } from 'react-parallax'
import ShapeHeartImg from './shape-heart.png'
import style from './style.module.scss'

const BackgroundCarousel = ({ children, swiperActiveIndex }) => (
    <div className={style.background}>
        <div className={clsx(style.mask, style.cardHover)}>
            {children &&
                children.map((elmt, i) => {
                    const image = elmt?.props?.node?.block?.props?.image
                    if (!image) {
                        return null
                    }
                    return (
                        <Parallax
                            key={image.url}
                            className={clsx(
                                style.parallax,
                                i === swiperActiveIndex && style.activeParallax,
                            )}
                            bgImage={image.url}
                            bgImageAlt={image.title}
                            strength={200}
                        />
                    )
                })}
        </div>

        <img className={style.heart} src={ShapeHeartImg} alt="Forme de coeur" />
    </div>
)

export default BackgroundCarousel
